// extracted by mini-css-extract-plugin
export default {"radioCard":"RadioCard_radioCard__TmuZM","description":"RadioCard_description__FpHUJ"};